import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';

export const PASSWORD_RECOVERY_FALLBACK_ERROR = 'Something went wrong';

export const getPasswordRecoveryError = (error: unknown): string =>
  error instanceof ApiCallError ? getApiCallErrorMessage(error) : PASSWORD_RECOVERY_FALLBACK_ERROR;
